/** Textes « capacite » — le français fait foi. */
export const capacite = {
  titre: 'Trésorerie & prévision',
  sousTitre: 'Ce que vous avez encaissé n\'est pas ce que vous avez gagné ce mois-ci. Cet écran sépare les deux.',
  glissants: '12 mois glissants',
  infobulle: (libelle: string, m: string) => `${libelle} — potentiel ${m}`,
  legende: {
    restant: 'Restant à vendre',
    reserve: 'Réservé, pas encore encaissé',
    encaisse: 'Réservé ET déjà encaissé',
  },
  moisParMois: 'Mois par mois',
  colonnes: {
    mois: 'Mois', potentiel: 'Potentiel max', reserve: 'Réservé', dontEncaisse: 'dont déjà encaissé',
    restant: 'Restant à vendre', encaissements: 'Encaissements réels', ca: 'CA constaté', remplissage: 'Remplissage',
  },
};
